import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mandant-config-speichern';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantConfigSpeichernEffects {

    MandantConfigSpeichern$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MANDANT_CONFIG_SPEICHERN),
        mergeMap((x: ac.PostMandantConfigSpeichernAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMandantConfigSpeichern(x.mandantConfigRequest).pipe(
                map((result: any) => {
                    return new ac.PostMandantConfigSpeichernErfolgreichAction(result, x.mandantConfigRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMandantConfigSpeichernFehlerAction(error, x.mandantConfigRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantVerwaltungService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantVerwaltungService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantVerwaltungService);
        }
        return this.service;
    }
}
